import { render, staticRenderFns } from "./task-center.vue?vue&type=template&id=42dc428c&scoped=true"
import script from "./task-center.vue?vue&type=script&lang=js"
export * from "./task-center.vue?vue&type=script&lang=js"
import style0 from "./task-center.less?vue&type=style&index=0&id=42dc428c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc428c",
  null
  
)

export default component.exports